export const TEXTS_DATA = {
  // todo: заполнить текстами типовые ошибки
  INVALID_EMAIL_FORMAT: '',
  FIELD_REQUIRED: '',
};
